var AWS = require('aws-sdk');
var s3TargetFolder = "dev";

function getS3Url(credentials, file, fileContenet, folderName) {

    AWS.config.update({
        accessKeyId: credentials.AccessKeyId,
        secretAccessKey: credentials.SecretAccessKey,
        sessionToken: credentials.SessionToken,
        region: 'ap-southeast-1'
    });

    var s3 = new AWS.S3();

    const fileType = file.type;
    const pathName = new Date().toISOString().replace(/[^\w]/g, "") + file.name.replace(/\s/g, '');

    const s3Params = {
        Bucket: 'ef-staging-videos',
        Key: s3TargetFolder + "/" + folderName + "/" + pathName,
        ContentType: fileType,
        Body: fileContenet,
        ACL: 'public-read'
    }

    return new Promise((resolve, reject) => {
        s3.upload(s3Params, function (err, data) {

            if (err) {
                return reject(err);
            }

            return resolve(data);
        });
    });
}

export default { getS3Url }
